import { useEffect, useState } from "react";
import { apiRequest } from "../../api";

export default function TestDataView() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    async function loadData() {
      try {
        const response = await apiRequest("/gathered-data/");
        setData(response.radio_checks);
      } catch (err) {
        setError(err.message || "Unable to load data.");
      } finally {
        setLoading(false);
      }
    }

    loadData();
  }, []);

  if (loading) {
    return <div className="workspace-panel">Loading...</div>;
  }

  if (error) {
    return <div className="workspace-panel">{error}</div>;
  }

  return (
    <div className="workspace-panel">
      <h2>Gathered Data</h2>

      {Object.entries(data).map(([key, section]) => {
        let parsed = section.data;

        try {
          parsed = JSON.parse(section.data);
        } catch (e) {}

        return (
          <div
            key={key}
            style={{
              border: "1px solid #ddd",
              marginBottom: "20px",
              borderRadius: "6px",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                padding: "10px",
                color: "white",
                fontWeight: "bold",
                background:
                  section.color === "g"
                    ? "green"
                    : section.color === "r"
                    ? "red"
                    : "orange",
              }}
            >
              {key} - {section.message}
            </div>

            <div style={{ padding: "15px" }}>
              <pre
                style={{
                  whiteSpace: "pre-wrap",
                  wordBreak: "break-word",
                  margin: 0,
                }}
              >
                {JSON.stringify(parsed, null, 2)}
              </pre>
            </div>
          </div>
        );
      })}
    </div>
  );
}